var PaymentUpdatePaymentMethodsStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

	var PaymentUpdatePaymentMethodsStrategy = function (attrs) {
		PaymentStrategy.apply(this, arguments);

		_.extend(this, {
			PaymentMethods: null
		}, attrs);
	};

	PaymentUpdatePaymentMethodsStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
		constructor: PaymentUpdatePaymentMethodsStrategy,

		afterComplete: function (data) {
			this._updatePaymentMethods(data);
		},

		_updatePaymentMethods: function (data) {
			this.PaymentMethods.setData(data);
		}
	});

	return PaymentUpdatePaymentMethodsStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
